import { SVGProps } from 'react';

const ListCollapse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 12h11m-11 6h11M10 6h11M3 10l3-3-3-3m0 16 3-3-3-3"
    />
  </svg>
);
export default ListCollapse;
